import React from "react";
// components
import MNPGV2 from "./MNPGV2";
// types
import { TMainPageLayoutV2 } from "../type";


const MNPG001 = ( props: TMainPageLayoutV2 ) => {
    console.log("MNPG001.rendered: ", props);

    if ( !props.template || !props.templates ) return null;

    return (
        <div className="header-top-section">
            <div className="container">
                <div className="header-top-wrapper">
                    <MNPGV2 templates={props.templates} mapLayoutName={props.template.mapLayoutName} parentId={props.template.id} />
                </div>
            </div>
        </div>
    )
}

const Component = React.memo(MNPG001, ( prevProps:TMainPageLayoutV2, nextProps:TMainPageLayoutV2 ) => {
    console.log("MNPG001.memo", { prevProps, nextProps });
    return true;
});

export default Component;